import { render, staticRenderFns } from "./ListFeature.vue?vue&type=template&id=2496afd8&"
import script from "./ListFeature.vue?vue&type=script&lang=js&"
export * from "./ListFeature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ListFeature.vue"
export default component.exports